import { render, staticRenderFns } from "./StatisticsTitle.vue?vue&type=template&id=6cd5cc70&scoped=true&"
import script from "./StatisticsTitle.vue?vue&type=script&lang=js&"
export * from "./StatisticsTitle.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsTitle.vue?vue&type=style&index=0&id=6cd5cc70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd5cc70",
  null
  
)

export default component.exports